import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';

import { theme, getInputFormattedDateFromString } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import Progress from './progress.js';
import CreditListItem from './creditListItem.js';
import { Paginator } from './paginator.js';
import SearchInvoice from '../components/searchInvoice.js';

function ClientCreditInfo(props){
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [filteredCredits, setFilteredCredits] = useState(props.client.credits);
  const [offset, setOffset] = useState(0);
  const [credits, setCredits] = useState(props.client.credits);
  const [description, setDescription] = useState(null);
  const [notifySms, setNotifySms] = useState(0);
  const [notifyMail, setNotifyMail] = useState(0);
  const [amount, setAmount] = useState(0);
  const [currency, setCurrency] = useState('INR');
  const [validTill, setValidTill] = useState(getInputFormattedDateFromString(Date.now()));
  const [createdDate, setCreatedDate] = useState(getInputFormattedDateFromString(Date.now()));
  const [remark, setRemark] = useState(null);
  const [invoice, setInvoice] = useState(null);

  let searchForm = useRef();

  const handleSearch = (event) => {
    const target = event.target;
    const value = target.value;
    const filtered = [];
    for(let i = 0;i<credits.length;i++){
      if(value === undefined || value.trim() === '' || credits[i].description.indexOf(value) >= 0 || credits[i].updation_date.indexOf(value) >= 0 || credits[i].amount.indexOf(value) >= 0 || credits[i].status.indexOf(value) >= 0){
        filtered.push(credits[i]);
      }
    }
    setFilteredCredits(filtered);
  }

  const handleSubmit = (event) =>{
    event.preventDefault();
    if(amount && parseInt(amount) > 0 && description && validTill && parseInt(amount) <= parseInt(invoice.paid)){
      const formData = new FormData;
      formData.append('description', description);
      formData.append('remark', remark);
      formData.append('valid_till', validTill);
      formData.append('createdDate', createdDate);
      formData.append('invoice', invoice.invoice_id);
      formData.append('task', "create");
      formData.append('client', props.id);
      formData.append('amount', amount);
      formData.append('currency', currency);
      formData.append('notifySms', notifySms);
      formData.append('notifyMail', notifyMail);
      formData.append('token', localStorage.getItem("token"));
      setLoading(true);
      axios.post(global.config.api_server+'credit',formData).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Credit Created');
          setTimeout(function(){
            window.location.reload();
          }, 1000);
        }else{
          alertService.error(res.data.error);
          setLoading(false);
        }
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Fields must have valid values');
      setLoading(false);
    }
  }

  const handleNotifySms = (event) =>{
    if(event.target.checked){
      setNotifySms(1);
    }else{
      setNotifySms(0);
    }
  }

  const handleNotifyMail = (event) =>{
    if(event.target.checked){
      setNotifyMail(1);
    }else{
      setNotifyMail(0);
    }
  }

  const resetSearch = (event) => {
    searchForm.current.reset();
    setSearch('');
    setFilteredCredits(credits);
  }

  const onPageChange = (index_start) => {
    setOffset(index_start);
  }  

  let createCredit = "";
  if(parseInt(localStorage.getItem("role")) >= 3){
    createCredit = <a href="#" className={'btn btn-icon-split float-right btn-'+theme()} data-toggle="modal" data-target="#createCreditModal">
                  <span className="icon text-white-50">
                    <i className="fas fa-credit-card"></i>
                  </span>
                  <span className="text">Add New Credit</span>
                </a>;
  }
  let total = 0;
  let counter = 0;
  let offsetCounter = 0;
  const paginated_credits = [];
  for (const u of filteredCredits) {
    total++;
    offsetCounter++;
    if (offsetCounter > offset && counter < global.config.items_per_page){
      counter++;
      paginated_credits.push(u);
    }
  }
  return(
    <div>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          {createCredit}
          <form ref={searchForm} className="form-inline">
              <h6 className={'form-group mr-3 font-weight-bold text-'+theme()}>Client - Credits(s)</h6>
              <div className="form-group mr-3">
                <input type="search" label="search" className="form-control" placeholder="Search" onChange={handleSearch}/>
              </div>
              {search &&
              <div className="form-group mr-3">
                <a href="#" className="btn btn-default btn-icon-split" onClick={resetSearch}>
                  <span className="icon">
                    <i className="fas fa-times"></i>
                  </span>
                </a>
              </div>
              }
            </form>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div className="row">
            {loading === true ? (
              <Progress label='Loading..' small={true}/>
            ):null}
              <div className="col-sm-12">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Credit Id</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>Updated On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginated_credits.map(credit =>
                      <CreditListItem info={credit} key={credit.credit_id} type="client"/>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <Paginator
                itemCount={total}
                itemsPerPage={global.config.items_per_page}
                showNextPages={2}
                showPrevPages={2}
                filterTotal={filteredCredits.length}
                grandTotal={credits.length}
                onClick={onPageChange.bind(this)}
              />
          </div>
        </div>
      </div>
      <div className="modal fade" id="createCreditModal" tabIndex="-1" role="dialog" aria-labelledby="create-popup" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="create-popup">Create Credit</h5>
              <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <SearchInvoice handleSubmit={(e) => { setInvoice(e); setCurrency(e.currency);}} client={props.id}></SearchInvoice>
                {invoice && 
                  <div>
                    <div className="form-group">
                      <label>Amount (Less than or equal to: {invoice.paid})</label>
                      <input type="number" value={amount} maxLength="50" name="amount" className="form-control" id="amount" placeholder="Enter Amount" onChange={(e) => setAmount(e.target.value)}/>
                    </div>
                    <div className="form-group">
                      <label>Currency</label>
                      <select value={currency} name="currency" className="form-control" onChange={(e) => setCurrency(e.target.value)}>
                        {global.config.currencies.split(",").map(d =>
                            <option value={d} key={d}>{d}</option>
                        )}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Description</label>
                      <textarea maxLength="400" name="description" className="form-control textarea-lg" id="description" placeholder="Description" onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                    <div className="form-group">
                      <label>Valid Till</label>
                      <input type="date" value={validTill} maxLength="50" name="validTill" className="form-control" id="validTill" placeholder="Enter Valid Till" onChange={(e) => setValidTill(e.target.value)}/>
                    </div>
                    <div className="form-group">
                      <label>Creation Date</label>
                      <input type="date" value={createdDate} maxLength="50" name="createdDate" className="form-control" id="createdDate" placeholder="Enter Created Date" onChange={(e) => setCreatedDate(e.target.value)}/>
                    </div>
                    <div className="form-group">
                      <label>Additional Note</label>
                      <textarea maxLength="200" value={remark} name="remark" className="form-control textarea-md" id="remark" placeholder="Additional Note" onChange={(e) => setRemark(e.target.value)}></textarea>
                    </div>
                    <div className="form-group">
                      <input type="checkbox" onChange={(e) => handleNotifyMail(e)}/> Send Mail &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox" onChange={(e) => handleNotifySms(e)}/> Send SMS
                    </div>
                  </div>
                }
                {loading === true ? (
                  <Progress label='Creating..' small={true}/>
                ):null}
              </div>
              <div className="modal-footer">
                <button className="btn btn-default" type="reset" data-dismiss="modal">Close</button>
                <button className={'btn btn-'+theme()} type="button" onClick={handleSubmit}>Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientCreditInfo;